<template>
  <li :title="formatTitle(data.title)" class="layout-menu-card">
    <a>
      <div class="icon-box" :class="{'icon-box-remind': remindShow}"  @click="pushRoute(data.url)">
        <span class="svg"
            :style="getSvgStyle(data.subSystem, data.icon)"></span>
      </div>
      <p>{{data.title}}</p>
    </a>
  </li>
</template>

<script>
  import bus from 'public/utils/bus'
  import { systemIconColors } from '@/layout/layout/conf'
  import { QtReportOpenMenuByFavorite } from '@/layout/utils/report-qt.js'

  export default {
    props: {
      data: Object,
      remindShow: Boolean
    },
    computed: {
      visitedViews () {
        return this.$store.state.tagsView.visitedViews
      }
    },
    methods: {
      formatTitle (title) {
        return title && title.length > 7 ? title : ''
      },
      pushRoute (path) {
        // 从框架布局进入，添加入口标记
        const route = this.$router.resolve(path).route
        route.meta.layout = true
        bus.$emit('GLOBAL_USE_OPEN_MODULE', route.meta.tag || path)
        const currentRoute = this.visitedViews.find(t => t.tag === path)
        if (currentRoute) {
          this.$router.push(currentRoute.path)
          this.$bus.$emit('TAB_CLICK', currentRoute.path, currentRoute.tag)
          QtReportOpenMenuByFavorite(currentRoute.path)
        } else {
          this.$router.push(path)
          this.$bus.$emit('TAB_CLICK', path, path)
          QtReportOpenMenuByFavorite(path)
        }
      },
      getSvgStyle (subSystem, icon) {
        return {
          maskImage: `url(${icon})`,
          backgroundColor: systemIconColors[subSystem] || systemIconColors.HOME
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.layout-menu-card {
  width: 92px;
  margin: 0 2px 4px;
  padding: 10px 0;
  text-align: center;
  // background-color: #f5f5fa;
  border-radius: 2px;
  .icon-box {
    background: #F5F7FA;
    width: 50px;
    height: 50px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;
    justify-content: center;
    margin: 0 auto;
    position: relative;
    &-remind {
      &::before {
        content: '';
        background: #FF5555;
        width: 6px;
        height: 6px;
        position: absolute;
        border-radius: 50%;
        right: -3px;
        top: -3px;
      }
    }
    &:hover {
      background: var(--g-color-primary);
      .svg {
        filter: brightness(0) invert(1);
      }
    }
  }
  .icon {
    font-size: 24px;
    color: var(--g-color-primary);
    width: 24px;
    height: 24px;
    display: inline-block;
  }
  .svg {
    width: 24px;
    height: 24px;
    display: inline-block;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: contain;
  }
  a {
    display: block;
  }
  p {
    margin-top: 6px;
    padding: 0 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-list/menu-item.vue